import { WBBox, WBFlex, WBTooltip, WBTypography } from '@admiin-com/ds-web';
import { t } from 'i18next';
import { Switch } from '@mui/material';
export const PayFormSwitch = ({
  value,
  onChange,
  disabled,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
}) => {
  return (
    <WBFlex mt={5} alignItems={'center'} justifyContent={'space-between'}>
      <WBBox>
        <WBTypography variant="h5">
          {t('signaturePayTitle', { ns: 'taskbox' })}
        </WBTypography>
        <WBTypography color={'text.secondary'}>
          {t('signaturePaySubTitle', { ns: 'taskbox' })}
        </WBTypography>
      </WBBox>
      <WBTooltip
        title={
          disabled ? t('nonAbnSignaturePayDisabled', { ns: 'taskbox' }) : ''
        }
      >
        <Switch
          inputProps={{ 'aria-label': 'controlled' }}
          checked={value}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
        />
      </WBTooltip>
    </WBFlex>
  );
};
